"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const E = require("fp-ts/lib/Either");
const pipeable_1 = require("fp-ts/lib/pipeable");
const number_1 = require("./number");
function eurosInRangeV(path, min, max) {
    return x => pipeable_1.pipe(number_1.range(path, min.euros(), max.euros(), '€')(x.euros()), E.map(_ => x));
}
exports.eurosInRangeV = eurosInRangeV;
function eurosLte(path, min) {
    return x => pipeable_1.pipe(number_1.lte(path, min.euros(), '€')(x.euros()), E.map(_ => x));
}
exports.eurosLte = eurosLte;
function eurosGte(path, max) {
    return x => pipeable_1.pipe(number_1.gte(path, max.euros(), '€')(x.euros()), E.map(_ => x));
}
exports.eurosGte = eurosGte;
